import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { usePortalAuth } from "../../contexts/PortalAuthContext";
import BeatLoader from "react-spinners/BeatLoader";

const PortalProtected = ({ children }) => {
  const { ready, authenticated } = usePortalAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <BeatLoader color="#03C9D7" />
      </div>
    );
  }

  if (!authenticated) {
    return (
      <Navigate to="/merchant-portal/login" replace state={{ from: location }} />
    );
  }

  return children;
};

export default PortalProtected;
